<template>
  <b-container class="my-4">
    <b-row class="align-items-center">
      <b-col cols="12" lg="4" sm="12" class="text-center">
        <b-button class="navButton" v-if="previousPage" :to="previousPage.url" variant="primary">
          &lt; Előző oldal
        </b-button>
        <b-button class="navButton" v-else variant="secondary" disabled>
          &lt; Előző oldal
        </b-button>
      </b-col>
      <b-col cols="12" lg="4" sm="12" class="text-center">
        <b-button class="navButton" :to="'/ESG'" variant="warning">
          ESG főoldal
        </b-button>
      </b-col>
      <b-col cols="12" lg="4" sm="12" class="text-center">
        <b-button class="navButton" v-if="nextPage" :to="nextPage.url" variant="primary">
          Következő oldal &gt;
        </b-button>
        <b-button class="navButton" v-else variant="secondary" disabled>
          Következő oldal &gt;
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      pages: [
        { name: 'ESG', title: 'ESG', url: '/ESG' },
        { name: 'Szolgaltatasok', title: 'ESG Kompetencia Központ', url: '/ESG/Szolgaltatasok' },
        { name: 'Akkreditacio', title: 'Oktató intézmények akkreditációja', url: '/ESG/Akkreditacio' },
        { name: 'Intezmenyek', title: 'Akkreditált intézmények nyilvántartása', url: '/ESG/Intezmenyek' },
        { name: 'Vallalkozasok', title: 'ESG a vállalkozások életében', url: '/ESG/Vallalkozasok' },
        { name: 'Treningek', title: 'Piaci ESG tréningek', url: '/ESG/Treningek' },
        {
          name: 'Kezikonyvek-utmutatok',
          title: 'Útmutatók, kézikönyvek, segédletek',
          url: '/ESG/Kezikonyvek-utmutatok'
        },
        { name: 'ESG', title: 'ESG', url: '/ESG' }
      ]
    }
  },
  computed: {
    currentIndex() {
      const currentName = this.$route.name
      const index = this.pages.findIndex(page => page.name === currentName)
      // Opcionális: ha nincs match, logold ki a hibát
      if (index === -1) {
        console.warn(`Route name "${currentName}" not found in pages array.`)
      }
      return index
    },
    previousPage() {
      // Lineáris: csak ha nem az első oldal
      return this.currentIndex > 0 ? this.pages[this.currentIndex - 1] : null
    },
    nextPage() {
      // Lineáris: csak ha nem az utolsó oldal
      return this.currentIndex < this.pages.length - 1 ? this.pages[this.currentIndex + 1] : null
    }
  }
}
</script>

<style scoped>
.navButton {
  min-width: 180px;
  background-color: #00903c !important;
  color: white;
  font-weight: bold;
  padding-top: 0.7rem;
  border: none; /* Eltávolítja az outline keretet, ha maradna */
}
@media (max-width: 768px) {
  .navButton {
    padding: auto;
  }
}
</style>
